import React from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
} from "@chakra-ui/react";

interface ResubmitConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  visitCount: number;
  onConfirm: () => void;
  isLoading: boolean;
  /** Extra line under the message, e.g. how many of a selection can be re-submitted. */
  details?: string;
}

export function ResubmitConfirmationDialog({
  isOpen,
  onClose,
  visitCount,
  onConfirm,
  isLoading,
  details,
}: ResubmitConfirmationDialogProps) {
  const cancelRef = React.useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Re-submit EVV Visits
          </AlertDialogHeader>

          <AlertDialogBody>
            Are you sure you want to re-submit {visitCount} visit(s)? This will clear any existing
            submission state and trigger a new submission to the contract&apos;s EVV aggregator.
            {details !== undefined && <Text mt={3}>{details}</Text>}
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} isDisabled={isLoading} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme="blue" isLoading={isLoading} ml={3} onClick={onConfirm}>
              Re-submit
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
